import Vue from 'vue'
import Router from 'vue-router'

// Containers
import Full from '@/containers/Full'

Vue.use(Router)

function load (component) {
  // '@' is aliased to src/components
  return () =>
        import(`@/${component}.vue`)
}

const router = new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [{
    path: '/',
    redirect: '/panel-de-control',
    name: 'Home',
    component: Full,
    meta: { requiresAuth: true },
    children: [{
      path: 'panel-de-control',
      name: 'Panel de Control',
      component: load('views/Panel')
    },
    {
      path: 'archivos',
      name: 'Archivos',
      redirect: '/archivos/seriales',
      component: {
        render (c) { return c('router-view') }
      },
      children: [{
        path: 'seriales',
        name: 'Seriales',
        component: load('views/pages/seriales/Index'),
        redirect: '/archivos/seriales/lista',
        children: [{
          path: 'lista',
          name: 'Listar Seriales',
          component: load('views/pages/seriales/Lista')
        },
        {
          path: 'generar',
          name: 'Generar Seriales',
          component: load('views/pages/seriales/Formulario')
        },
        {
          path: ':lote',
          name: 'Cambiar contenido del Lote',
          component: load('views/pages/seriales/Formulario')
        },
        {
          path: ':lote/:id_serial',
          name: 'Modificar contenido del Serial',
          component: load('views/pages/seriales/Formulario')
        }]
      },
      {
        path: 'libros',
        name: 'Libros',
        component: load('views/pages/libros/Index'),
        redirect: '/archivos/libros/lista',
        children: [{
          path: 'lista',
          name: 'Listar Libros',
          component: load('views/pages/libros/Lista')
        },
        {
          path: 'nuevo',
          name: 'Nuevo Libro',
          component: load('views/pages/libros/Formulario')
        },
        {
          path: ':id_libro',
          name: 'Editar Libro',
          component: load('views/pages/libros/Formulario')
        }
        ]
      },

      {
        path: 'contenidos',
        name: 'Contenidos',
        component: load('views/pages/contenidos/Index'),
        redirect: '/archivos/contenidos/lista',
        children: [{
          path: 'lista',
          name: 'Listar Contenidos',
          component: load('views/pages/contenidos/Lista')
        },
        {
          path: 'nuevo',
          name: 'Nuevo Contenido',
          component: load('views/pages/contenidos/Formulario')
        },
        {
          path: ':id_contenido',
          name: 'Editar Contenido',
          component: load('views/pages/contenidos/Formulario')
        }
        ]
      },
      {
        path: 'instituciones',
        name: 'Instituciones',
        component: load('views/pages/ComingSoon')
        /*
                                component: load('views/pages/instituciones/Index'),
                                redirect: '/archivos/instituciones/lista',
                                children: [
                                  {
                                  path: 'lista',
                                  name: 'Listar Instituciones',
                                  component: load('views/pages/instituciones/Lista')
                                  },
                                  {
                                  path: 'nuevo',
                                  name: 'Nueva Institucion',
                                  component: load('views/pages/instituciones/Ingreso')
                                  }
                                ]
                                */
      },
      {
        path: 'docentes',
        name: 'Docentes',
        component: load('views/pages/ComingSoon')
        /*
                                component: load('views/pages/docentes/Index'),
                                redirect: '/archivos/docentes/lista',
                                children: [
                                  {
                                  path: 'lista',
                                  name: 'Listar Docentes',
                                  component: load('views/pages/docentes/Lista')
                                  },
                                  {
                                  path: 'nuevo',
                                  name: 'Nuevo Docente',
                                  component: load('views/pages/docentes/Ingreso')
                                  }
                                ]
                                */
      },
      {
        path: 'alumnos',
        name: 'Alumnos',
        component: load('views/pages/ComingSoon')
        /*
                                component: load('views/pages/alumnos/Index'),
                                redirect: '/archivos/alumnos/lista',
                                children: [
                                  {
                                  path: 'lista',
                                  name: 'Listar Alumnos',
                                  component: load('views/pages/alumnos/Lista')
                                  },
                                  {
                                  path: 'nuevo',
                                  name: 'Nuevo Alumno',
                                  component: load('views/pages/alumnos/Ingreso')
                                  }
                                ]
                                */
      }
      ]
    }, // /archivos
    {
      path: 'reportes',
      name: 'Reportes',
      redirect: '/reportes/historial',
      component: {
        render (c) { return c('router-view') }
      },
      children: [{
        path: 'historial',
        name: 'Historial',
        component: load('views/pages/ComingSoon')
      }]
    }, // /reportes
    {
      path: 'seguridad',
      name: 'Seguridad',
      redirect: '/seguridad/usuarios',
      component: {
        render (c) { return c('router-view') }
      },
      children: [{
        path: 'usuarios',
        name: 'Usuarios',
        component: load('views/pages/ComingSoon')
      },
      {
        path: 'grupos',
        name: 'Grupos',
        component: load('views/pages/ComingSoon')
      },
      {
        path: 'permisos',
        name: 'Permisos',
        component: load('views/pages/ComingSoon')
      }
      ]
    }, // /seguridad
    {
      path: 'configuracion',
      name: 'Configuración',
      component: load('views/pages/ComingSoon')
    }
    ]
  },

    // Ingreso o Registro en caso de que no esté autenticado el usuario
  { path: '/sin-identificar', component: load('views/pages/Login') },

    // Always leave this last one
  { path: '*', component: load('views/pages/Page404') } // Not found
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!sessionStorage.getItem('apiKey')) {
      next({
        path: '/sin-identificar'
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js